import React, { useCallback } from 'react'
import { Trans } from 'react-i18next'
import BaseGrinNotification from './BaseGrinNotification/BaseGrinNotification'
import useSelectPatient from 'hooks/useSelectPatient'
import GenericNotificationBody from './BaseGrinNotification/GenericNotificationBody'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'

/**
 * @param {NotificationComponentProps} props
 */
const MessageReaction = ({ grinNotification, options }) => {
  const selectPatient = useSelectPatient({ patientId: grinNotification?.relatedPatientId })

  const handleClick = useCallback(() => {
    selectPatient()
  }, [selectPatient])

  return (
    <BaseGrinNotification
      grinNotification={grinNotification}
      isLastItem={options.isLastItem}
      showPracticeName={options.showPracticeName}
      profilePictureUserName={grinNotification.payload.requestorName}
      profilePicture={grinNotification.payload.requesterPicture}
      onClick={handleClick}
    >
      <GenericNotificationBody
        text={
          <DazzedParagraph14>
            <Trans
              i18nKey={'dialogs.notificationCenterDialog.feed.notifications.messageReaction.body'}
              values={{
                doctorName: grinNotification.payload.requestorName,
                reaction: grinNotification.payload.reaction
              }}
            />
          </DazzedParagraph14>
        }
        withEllipsis
      />
    </BaseGrinNotification>
  )
}

export default MessageReaction
